define('Components/StopSMSWidget/js/views/StopSMSWidgetInstanceView',['WidgetInstanceView','phoneUtils','template!Components/StopSMSWidget/templates/default','InputPhoneView','app'

    ],
    function(WidgetInstanceView,phoneUtils,defaultTemplate,InputPhoneView,app){
    return WidgetInstanceView.extend({
        name:'StopSMSWidgetInstanceView',
        events: {
            'submit form':'onSubmit',
        },
        getTemplate:function(){
            // étant donné qu'il n'y a un seul template, on épargne le switch case.
            return defaultTemplate;
            /*
            switch(this.model.getTemplate()){
                case 'default': default: return defaultTemplate;
            }
            */
        },
        afterRender:function(){
            var view = this;
            InputPhoneView.initializeInputsOfView(view);
        },
        onSubmit:function(e){
            //
            var view = this,
                model = view.model,
                input = view.$('input[name="stop_sms_phone"]'),
                submit = view.$('.btn-classic'),
                E164 = input.data('E164'),
                phone = phoneUtils.validate(E164);
            ;
            e.stopPropagation();
            e.preventDefault();
            //return

            if(phone){
                submit.addClass('loading');
                model.once('responseStopSMS',function(message){
                    app.banNotice(message);
                    input.val('');
                    input.trigger('change');
                    submit.removeClass('loading');
                });
                model.requestStopSMS(phone);
            }else{
                app.banNotice(app.t('Merci de saisir un numéro de téléphone valide.', 'StopSMS'));
            }
        },

    })
});
